import { EFeaturesActionType } from './types';
import { updateFeatureProperties } from './updateFeatureProperies';
import { TFeature, TFeatureWithPrecision } from '../../../common/types/map';
import { TThunkAction } from '../../../common/types/redux';
import { actionGenerator } from '../../../common/utils/redux/actionGenerator';
import { selectActiveFeature } from '../../selectors';

export const setSelectedFeature = actionGenerator<EFeaturesActionType.FeatureSelected, TFeatureWithPrecision>(
  EFeaturesActionType.FeatureSelected,
);

export function selectFeature(feature: TFeature, precision: number): TThunkAction {
  return (dispatch, getState) => {
    const activeFeature = selectActiveFeature(getState());

    dispatch(setSelectedFeature({ ...feature, precision }));

    if (activeFeature) {
      dispatch(
        updateFeatureProperties({
          featureId: activeFeature.id,
          precision: activeFeature.precision,
          properties: { isActive: false },
        }),
      );
    }
    dispatch(updateFeatureProperties({ featureId: feature.id, precision, properties: { isActive: true } }));
  };
}
